<template>
  <div class="form-inform">
      <div class="modal-body">
        <div class="all-notice" ref="allNotice" v-if="formInforms.length>0" >
          <div v-for="(item,index) in formInforms" :key="index" class="item-notice">
            <div class="title">通知{{index+1}}</div>
            <el-form ref="form" class="form" :model="item" label-position="left" label-width="80px" :inline="true">
                <el-form-item label="触发类型" prop="type" :rules=" {required: true, message: '请选择触发类型', trigger: 'change'}">
                  <el-select v-model="item.type" placeholder="请选择触发类型" class="select-width" disabled>
                    <el-option label="新建" value="create"></el-option>
                    <el-option label="修改" value="update"></el-option>
                    <el-option label="删除" value="delete"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="通知条件" class="expression-item">
                  <div class="calculate" :title="expressionShow(item.condition)" v-html="expressionShow(item.condition)">{{item.condition}}</div>
                </el-form-item>
                <el-form-item label="通知对象" class="expression-item"  prop="targets" :rules=" {required: true, message: '请选择通知对象', trigger: 'blur'}">
                  <el-select class="select-type" v-model="item.selectType" placeholder="请选择" @change="item.targets=[]" disabled>
                    <el-option label="自定义" value="user"></el-option>
                    <el-option label="来源控件" value="component"></el-option>
                  </el-select>
                  <span class="candidates" v-if="item.selectType==='user'"  @click="openDialogCustom(item,index)" :title="titletarget(item.targets)">请选择
                    <span class="candidate-item"  v-for="item in item.targets" :key="item.id"> {{item.name}} </span>
                  </span>
                  <el-select disabled class="candidate-select" v-model="item.targets" v-else multiple collapse-tags placeholder="请选择控件名称"  value-key="id" @change="vilidateTarget(index)">
                    <el-option v-for="(com) in allChildren(item.targets)" :key="com.id" :label="com.name" :value="com" ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="通知主题" class="expression-item" prop="theme" :rules=" {required: true, message: '请输入通知主题', trigger: 'blur'}">
                  <div class="calculate" :title="expressionShow(item.theme)" v-html="expressionShow(item.theme)">{{item.theme}}</div>
                </el-form-item>
                <el-form-item label="通知内容" class="expression-item" prop="content" :rules=" {required: true, message: '请输入通知内容', trigger: 'blur'}">
                  <div class="calculate"  :title="expressionShow(item.content)" v-html="expressionShow(item.content)">{{item.content}}</div>
                </el-form-item>
                <el-form-item label="通知方式" class="expression-item" prop="style" :rules=" {required: true, message: '请输入通知内容', trigger: 'change'}" >
                  <el-checkbox-group v-model="item.style" disabled>
                    <el-checkbox label="email">邮件</el-checkbox>
                    <el-checkbox label="app">APP</el-checkbox>
                    <el-checkbox label="sms">短信</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
            </el-form>
            </div>
        </div>
      <div v-else class="center">无通知</div>
      </div>
      <new-select-people v-if="selectInformDialog.visable" :data="selectInformDialog" @getCandidate="getCandidate"></new-select-people>
  </div>
</template>

<script>
import NewSelectPeople from '@/components/system/system/new-select-people.vue'
export default {
  name: 'FormNotices',
  props: ['formNotices'],
  components: {
    NewSelectPeople
  },
  data () {
    return {
      formInforms: this.formNotices,
      informContent: '默认内容',
      selectInformDialog: {
        visable: false,
        data: [],
        title: '选择人员',
        isSingle: false,
        selectType: ['user']
      }
    }
  },
  computed: {
    allChildren () {
      return names => names
    },
    titletarget () {
      return names => names.length && names.map(m => m.name)
    }
  },
  methods: {
    vilidateTarget (index) {
      this.$refs.form[index].validateField('targets')
    },
    openDialogCustom (item, index) {
      this.selectInformDialog.index = index
      this.selectInformDialog.visable = true
      this.selectInformDialog.noticeId = item.id
      this.selectInformDialog.data = item.targets
    },
    getCandidate (candidate) {
      let notice = this.formInforms.find(m => m.id === this.selectInformDialog.noticeId)
      notice.targets = candidate
      this.selectInformDialog.visable = false
      this.$refs.form[this.selectInformDialog.index].validateField('targets')
    },

    expressionShow (expression) {
      if (expression) {
        expression.match(/\$\{(.+?)\}/g) && expression.match(/\$\{(.+?)\}/g).forEach((el) => {
          let name = el.split(',')[1]
          expression = expression.replace(el, name)
        })
      }
      return expression
    },

    delNotice (index) {
      this.formInforms.splice(index, 1)
    },

    validate () {
      const validArr = []
      this.$refs.form && this.$refs.form.forEach((item) => {
        const result = new Promise((resolve, reject) => {
          item.validate((valid) => {
            if (valid) {
              resolve()
            } else {
              this.$message.info('通知必填')
              reject(new Error('通知必填'))
            }
          })
        })
        validArr.push(result)
      })
      return validArr
    }

  }
}
</script>

<style lang="scss">
.form-inform {
  .modal-body .center {
    text-align: center;
  }
  .all-notice {
    max-height: 400px;
    overflow-y: auto;
    .item-notice {
      border: 1px solid #DBDBDB;
      border-radius: 4px;
      margin-bottom: 10px;

      .title {
        background: var(--light-9, #EBF5FF);
        height: 27px;
        line-height: 27px;
        padding-left: 8px;
        position: relative;
        margin-bottom: 10px;

        .close {
          position: absolute;
          top: 7px;
          right: 10px;
          color: #ADAFB0;
          cursor: pointer;
          display: none;

          &:hover {
            color: #FF2828;
          }
        }

        &:hover {
          .close {
            display: inline-block;
          }
        }
      }

      .calculate {
        width: 150px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        height: 28px;
        padding-left: 15px;
        background: rgb(235, 235, 235);
        overflow-y: auto;
        text-align: left;
      }

      .el-select {
        width: 150px;

        &.select-type {

          float: left;
        }
      }

      .candidate-select {
        margin-left: 20px;
        color: var(--primary, #54ABF1);
        cursor: pointer;
        width: 224px;
      }

      .candidates {
        float: left;
        margin-left: 20px;
        color: var(--primary, #54ABF1);
        cursor: pointer;
        width: 222px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
    }
  }

  .add-notice {
    text-align: center;
    width: 100%;
    cursor: pointer;
    color: #232323;
    margin: 0 auto;
    margin-top: 10px;

    &:hover {
      color: var(--primary, #54ABF1);
    }

    &:active {
      color: var(--shade-1, #54ABF1)
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/form/design/form-notices.vue